import { getCartData } from "@Modules/eventPage/utils/cart";
import { GST_STATUS } from "@Utils/constants/payment";
import {
    calculatePaymentInfoForSingleOffering,
    getBillingDataFromPaymentInfos,
} from "@Utils/payment";
import { LISTING_TYPES } from "repoV2/constants/listing";
import { CURRENCY_STRINGS } from "repoV2/constants/payment";

export const getCartGtagData = () => {
    const cartData = getCartData();
    const cartCurrencySymbol =
        cartData?.currency?.currencyString || CURRENCY_STRINGS.INR;
    const listingMap = cartData?.listingMap || {};
    const cartItemUuids = Object.keys(listingMap) || [];
    const netPaymentValues = cartItemUuids.map(uuid => {
        const {
            eventData,
            discount,
            quantity,
            slots,
            instalments,
            selectedPaymentType,
        } = listingMap[uuid] || {};
        const [initialPayment] = instalments || [];

        const paymentInfo = calculatePaymentInfoForSingleOffering({
            eventData: {
                ...eventData,
                gst_state: eventData?.gst_state || GST_STATUS.INAPPLICABLE,
            },
            numberOfCustomers: 1,
            slots,
            discountData: discount?.discountData,
            ...(eventData?.type === LISTING_TYPES.MERCHANDISE && {
                quantity: quantity || 1,
            }),
            selectedPaymentType,
            initialInstalment: initialPayment,
        });
        listingMap[uuid] = { ...listingMap[uuid], paymentInfo };
        return paymentInfo;
    });
    const billingData = getBillingDataFromPaymentInfos(netPaymentValues, 1);

    return {
        value: billingData.totalPrice,
        currency: cartCurrencySymbol,
        items: cartItemUuids.map(uuid => ({
            item_id: uuid,
            item_name: listingMap[uuid]?.eventData?.title,
        })),
    };
};
